import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './vuex/store';
// import Mock from './mock';
import axiosInstance from './plugins/axios';
import i18n from './plugins/i18n';

// console.log(Mock);
// Mock.init(axiosInstance);
// Mock.setup({ timeout: '200-600' });

Vue.config.productionTip = false;

Vue.config.devtools = true;

router.beforeEach((to ,from, next) => {
  var principal = localStorage.getItem('mldn-session-id');
  var session_prncipal = sessionStorage.getItem('principal');
  if (session_prncipal==null && principal=='temp') {
	  principal = null;
  }
  if (principal==null) {
    if (to.path != '/' && to.path != '/login') {
      next({
        path: '/login'
      })
    } else {
      next();
    }
  } else if (to.path == '/' || to.path == '/login' || to.path == '/index') {
    next({
      path: '/main'
    })
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
